import React, { useState, useRef, useEffect } from 'react';
import { DotHorizontalIcon } from 'shared/ui/icons';

const RowActionsPopover = ({ children, position = 'bottom' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  const togglePopover = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={popoverRef}>
      <button
        onClick={togglePopover}
        aria-label={'Actions Popover Table'}
        className="text-gray-500 hover:text-gray-700"
      >
        <DotHorizontalIcon />
      </button>
      {isOpen && (
        <div
          className={`absolute ${position === 'left' ? '-left-[9.5rem] -top-7' : '-left-[6.5rem]'} z-10 w-32 rounded-md border border-gray-200 bg-white shadow-lg`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export { RowActionsPopover };
export default RowActionsPopover;
